import React from 'react';
import autoBind from 'auto-bind';
import {
  Grid,
  Form,
  Input,
  Dropdown,
  Button,
  Message,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format, startOfDay, endOfDay } from 'date-fns';

import DatePicker from 'components/DatePicker';
import 'pages/Coupons/ActionBar.css';

const dateToString = date => (date ? format(date, 'd/M/yyyy') : null);

export class ActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props.filters };
    autoBind(this);
  }

  onStartDateChanged(date) {
    this.setState({
      startDate: date ? startOfDay(date) : null,
    });
  }

  onEndDateChanged(date) {
    this.setState({
      endDate: date ? endOfDay(date) : null,
    });
  }

  onStatusFilterChanged(event, { value }) {
    this.setState({
      status: value,
    });
  }

  onSearchKeywordChanged(event, { value }) {
    this.setState({
      searchKeyword: value,
    });
  }

  onResetFilter() {
    const { onApplyFilter } = this.props;
    this.setState(
      {
        startDate: null,
        endDate: null,
        status: 'all',
        searchKeyword: '',
      },
      () => onApplyFilter(this.state)
    );
  }

  renderCurrentFilterInfo() {
    const {
      filters: { startDate, endDate, status, statusOptions, searchKeyword },
    } = this.props;
    return (
      <Message info>
        <p>
          Showing
          <span> </span>
          <strong>{statusOptions.find(s => s.value === status).text}</strong>
          <span> </span>
          coupons
          {(startDate !== null || endDate !== null) && (
            <span>
              <span> </span>
              created
              {startDate !== null && (
                <span>
                  <span> </span>
                  from <strong>{dateToString(startDate)}</strong>
                </span>
              )}
              {endDate !== null && (
                <span>
                  <span> </span>
                  until
                  <span> </span>
                  <strong>{dateToString(endDate)}</strong>
                </span>
              )}
            </span>
          )}
          {searchKeyword.trim().length > 0 && (
            <span>
              <span> </span>
              containing keyword <strong>{searchKeyword}</strong>
            </span>
          )}
        </p>
      </Message>
    );
  }

  render() {
    const { startDate, endDate, status, searchKeyword } = this.state;
    const {
      filters: { statusOptions },
      onApplyFilter,
      onCreateButtonClicked,
      isLoading,
    } = this.props;
    return (
      <div>
        <Form>
          <Grid>
            <Grid.Column width="4">
              <label htmlFor="status-filter">Status</label>
              <Dropdown
                id="status-filter"
                options={statusOptions}
                fluid
                selection
                value={status}
                onChange={this.onStatusFilterChanged}
              />
            </Grid.Column>
            <Grid.Column width="4">
              <label htmlFor="start-created-date">Coupon created from</label>
              <DatePicker
                id="start-created-date"
                onChange={this.onStartDateChanged}
                selected={startDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width="4">
              <label htmlFor="end-created-date">to</label>
              <DatePicker
                id="end-created-date"
                onChange={this.onEndDateChanged}
                selected={endDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width="4">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label style={{ margin: '100%' }}>
                <span>&nbsp;</span>
              </label>
              <Button
                primary
                onClick={() => onApplyFilter(this.state)}
                loading={isLoading}
                disabled={isLoading}
              >
                Apply Filter
              </Button>
              <Button
                primary
                basic
                onClick={this.onResetFilter}
                loading={isLoading}
                disabled={isLoading}
              >
                Reset Filter
              </Button>
            </Grid.Column>
          </Grid>
        </Form>
        <br />
        <Grid>
          <Grid.Column width="12">
            <Input
              placeholder="Search for coupon code..."
              icon="search"
              onChange={this.onSearchKeywordChanged}
              value={searchKeyword}
              fluid
            />
          </Grid.Column>
          <Grid.Column width="3">
            <Button color="green" fluid onClick={onCreateButtonClicked}>
              + Create Coupon
            </Button>
          </Grid.Column>
        </Grid>
        {this.renderCurrentFilterInfo()}
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.billingCoupon.filters,
});

ActionBar.propTypes = {
  filters: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    status: PropTypes.string,
    statusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ),
    searchKeyword: PropTypes.string.isRequired,
  }).isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  onCreateButtonClicked: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ActionBar);
